export default __webpack_public_path__ + "static/kulturbahnhof-620fcaa163c65883a6a5dd2f850c33fa.svg";